<template>
  <div class="new-application">
    <el-card class="box-card">
      <!-- <div class="back" v-if="isShow">
        <i class="el-icon-back" @click="back"></i>
      </div> -->
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="isEdit"
          :showSaveBtn="false"
          :disabled="!isEdit"
          @submit="save(2)"
          @cancelForm="cancel"
        />
      </div>
      <!-- <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'25%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog> -->
    </el-card>
  </div>
</template>

<script>
import "@/components/dynamic-form"
import { addReceipt, getReceipt, updateReceipt, getInvoice,getProject } from "@/api/bill/receipt"
import { getDocumentCode } from "@/views/utils"
import initDict from "@/mixin/initDict"

export default {
  name: "ReceiptForm",
  mixins: [initDict],
  data() {
    return {
      id: "",
      form: { contractId: "" },
      isEdit: false,
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            label: "发票",
            key: "invoice",
            type: "databox",
            placeholder: "请选择项目",
            span: 8,
            props: {
              label: "title",
              value: "id"
            },
            url: "/invoicing",
            tableColumn: [
              {
                property: "title",
                label: "发票名称",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "contractName",
                label: "合同名称",
                align: "center",
                // query: {
                //   type: "input"
                // }
              },
              {
                property: "receivableEntry",
                label: "收款类型",
                align: "center",
                // formatter: cur => { this.receipTypes.find(item => item.value === cur.moneyId).label }
                formatter: cur => { if (cur) { const obj = this.receipTypes.find(item => item.value === cur.moneyId); return obj.label } }
              }
            ],
            extendParms: { flag: 1 },
            multiple: false,
             rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            ]
          },
          {
              span: 8,
              type: "input",
              key: "collectionAccount",
              label: "合同",
              disabled: true,
              readonly: false,
              value: "",
              placeholder: "",
            },
          {
            label: "项目",
            key: "project",
            type: "databox",
            placeholder: "请选择项目",
            span: 8,
            props: {
              label: "projectName",
              value: "code"
            },
            tableColumn: [
              {
                property: "projectName",
                label: "项目名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            tableData: [],
            // extendParms: { applyId: ''},
            multiple: false,
            disabled: true,
            //  rules: [
            //   {
            //     required: true,
            //     message: "不能为空",
            //     trigger: "change"
            //   }
            // ]
          },
          {
            label: "项目经理",
            key: "projectManager",
            type: "databox",
            disabled: true,
            span: 8,
            props: {
              label: "projectManagerName",
              value: "id"
            },
            url: "/projectDelivery",
            tableColumn: [
              {
                property: "projectName",
                label: "项目名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            label: "经营人",
            key: "operator",
            span: 8,
            type: "databox",
            disabled: true,
            props: {
              label: "name",
              value: "id"
            },
            url: "/invoicing",
            tableColumn: [
              {
                property: "title",
                label: "发牌名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {},
            multiple: false
          },
          {
            key: "customer",
            label: "客户名称",
            span: 8,
            type: "databox",
            disabled: true,
            props: {
              label: "customerName",
              value: "id"
            },
            url: "/projectDelivery",
            tableColumn: [
              {
                property: "projectName",
                label: "项目名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "select",
            key: "receiptType",
            label: "收款类型",
            span: 8,
            options: [],
            disabled: true
          },
          {
            type: "date",
            key: "receiptTime",
            label: "收款时间",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd",
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "input",
            key: "balance",
            label: "金额",
            placeholder: "请输入金额",
            value: "",
            span: 8,
            rules: [
              {
                required: true,
                message: "不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            disabled: false,
            value: "",
            placeholder: "请输入备注",
            span: 20,
             maxlength: 200,
          }
        ]
      },
      receipTypes: [],
      form2: {}, // hr审批
      assignData: {}, // hr审批人员信息
      stepShow: false,
      personStepData: []
    };
  },
  created() {
    this.id = this.$route.params.id;
     this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    if (this.id) {
      getReceipt(this.id).then(res => {
        const form = res.data;
        if (form.projectDelivery) {
           form.project = { code: form.projectDelivery.bsProject.code, projectName: form.projectDelivery.bsProject.name,
           projectManager: {id: form.projectDelivery.personManager.id , projectManagerName: form.projectDelivery.personManager.name},
           person: {id: form.projectDelivery.person.id, name: form.projectDelivery.person.name}};
          form.projectManager = {id: form.projectDelivery.personManager.id , projectManagerName: form.projectDelivery.personManager.name};
        }
        if (form.invoicingApply) {
          form.contractName = form.invoicingApply.contractName
          form.invoice = {title: form.invoicingApply.title,contractName: form.invoicingApply.contractName,id: form.invoicingId}
          form.operator = {id: form.invoicingApply.contractEntry.personManage.id, operatorName: form.invoicingApply.contractEntry.personManage.name};
          form.customer = {id: form.invoicingApply.contractEntry.customerSigning.id,customerName: form.invoicingApply.contractEntry.customerSigning.name};
        }
        this.form = form;
      });
    } else {
      this.form.code = getDocumentCode("SKD");
    }
    this.getDict("RECEIPT").then(res => {
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'receiptType')].options = res.data;
      this.receipTypes = res.data;
    });
  },
  watch: {
    "form.invoice.id": { // 发票值监听,带出项目id,合同名称 收款类型 合伙人（经营人姓名）
      handler(val) {
        if (val) {
          this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'project')],"disabled",false)
          // this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'project')],"url","/projectDelivery/selectProject")
          // this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'project')],"extendParms",{ applyId: val},)
          getProject({applyId: val}).then(res => {
            this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'project')],"tableData",res.data.records)
          })
          this.form.collectionAccount = this.form.invoice.contractName;
          if (!this.id && this.form.invoice) {
             this.form.receiptType = this.form.invoice.receivableEntry.moneyId
          }
          getInvoice(val).then(res => {
            const obj = res.data.contractEntry.personManage;
            this.form.operator = {id: obj.id, name: obj.name}
          })
          if (this.isEdit) {
            this.form.project = null
          }
        } else {
            this.$set(this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'project')],"disabled",true)
            this.form.collectionAccount = '';
            this.form.receiptType = ''
        }
      },
    },
    "form.project": {
      handler(val,oldVal) { // 项目值监听，带出经理、客户名称
        if (val) {
          if (val.personManager) {
              this.form.projectManager = {id: val.personManager.id , projectManagerName: val.personManager.name};
          }
          // if (val.person) {
          //    this.form.operator = {id: val.person.id, operatorName: val.person.name};
          // }
          if (val.bsProject) {
             this.form.customer = {id: val.bsProject.customer.id,customerName: val.bsProject.customer.name};
          }
          this.form.projectCode = val.id;
        }
      },
      deep: true
    }
  },
  methods: {

    // 保存
    save(status) {
      // console.log(this.getFormData(status))
      this.pull(this.getFormData(status));
    },
     close() {
       this.stepShow = false;
      },
    // 组装表单数据
    getFormData(status) {
        const index  = this.formConfig.formItemList.findIndex(ele => ele.key === 'project')
      if (this.formConfig.formItemList[index].tableData.length > 0 && !this.form.projectCode) {
         return this.$notify({ title: "项目不能为空！", type: "error", duration: 2500 });
      }
      this.form.billState = status;
      this.form.receiptTime = new Date(this.form.receiptTime).getTime();
      this.form.invoicingId = this.form.invoice.id
       if (status === 2) { // HR审批提交人信息
        this.form.from = "receipt"
      }
      const obj = this.form;
      return obj
    },
    cancel() {
      this.$router.go(-1);
    },
    back() {
      this.$router.go(-1);
    },
    pull(obj) {
      if (this.id) {
        updateReceipt(obj).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      } else {
        addReceipt(obj).then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "操作成功！",
              type: "success",
              duration: 2500
            });
            this.cancel();
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content-title {
  height: 40px;
  background-color: #e7eff6;
  padding-left: 20px;
  overflow: hidden;
  .title-icon {
    display: inline-block;
    margin-top: 8px;
    width: 4px;
    height: 24px;
    background-color: #1369a8;
    margin-right: 14px;
  }
  .title-details {
    overflow: hidden;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    font-family: SourceHanSansSC-regular;
  }
}
.el-icon-back {
  padding-bottom: 10px;
}
</style>
